import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";

export async function pos_getAll(economyID)
{
    const response = await GET(CompanyRoutes.Cashless.Pos.GetAll+economyID);
    return response;
}

export async function pos_create(economyID,email,name,type,pin)
{
    const response = await POST_JSON(CompanyRoutes.Cashless.Pos.Create,{
        economyID,email,name,type,pin
    });

    return response;
}